"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidationSchema = void 0;
var Yup = __importStar(require("yup"));
require("../validators");
var personalSchema_1 = require("./personalSchema");
var developerSchema_1 = require("./developerSchema");
var getValidationSchema = function (isDeveloper, isApartmentFormSubmitted, collapsedApartmentId, publishedAt, isSaveButtonClicked) {
    return isDeveloper
        ? Yup.object(developerSchema_1.getDeveloper(isApartmentFormSubmitted, collapsedApartmentId, publishedAt, isSaveButtonClicked))
        : Yup.object(personalSchema_1.getPersonal());
};
exports.getValidationSchema = getValidationSchema;
